// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
:root {
  --panel-bg-color: transparent;
  --panel-heading-bg-color: #c1c7cd;
  --panel-heading-color: #071c35;
  --panel-heading-hover-color: #faa718;
  --panel-heading-text-color: white;
  --panel-border-radius: 4px;
  --panel-heading-padding: 15px;
}

.src-js-components-accordion-styles-module__panelGroup--I5The {
  border-radius: var(--panel-border-radius);
}

.src-js-components-accordion-styles-module__panel--PJH9M {
  border: none;
  background-color: var(--panel-bg-color);
}

.src-js-components-accordion-styles-module__panelHeading--U09hT {
  background-color: var(--panel-heading-bg-color);
  border-radius: var(--panel-border-radius) var(--panel-border-radius) 0 0;
  color: var(--panel-heading-color);
  padding: var(--panel-heading-padding);
}

.src-js-components-accordion-styles-module__panelTitle--Wiig4 {
  display: inline-block;
}

.src-js-components-accordion-styles-module__leftSideIcon--xi23i:hover {
  color: var(--panel-heading-hover-color);
}

.src-js-components-accordion-styles-module__rightSideIcon--Rl6J2:hover {
  color: var(--panel-heading-text-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/js/components/accordion/styles.module.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;EAC/C,wEAAwE;EACxE,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":["/* Variables */\n:root {\n  --panel-bg-color: transparent;\n  --panel-heading-bg-color: #c1c7cd;\n  --panel-heading-color: #071c35;\n  --panel-heading-hover-color: #faa718;\n  --panel-heading-text-color: white;\n  --panel-border-radius: 4px;\n  --panel-heading-padding: 15px;\n}\n\n.panelGroup {\n  border-radius: var(--panel-border-radius);\n}\n\n.panel {\n  border: none;\n  background-color: var(--panel-bg-color);\n}\n\n.panelHeading {\n  background-color: var(--panel-heading-bg-color);\n  border-radius: var(--panel-border-radius) var(--panel-border-radius) 0 0;\n  color: var(--panel-heading-color);\n  padding: var(--panel-heading-padding);\n}\n\n.panelTitle {\n  display: inline-block;\n}\n\n.leftSideIcon:hover {\n  color: var(--panel-heading-hover-color);\n}\n\n.rightSideIcon:hover {\n  color: var(--panel-heading-text-color) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelGroup": `src-js-components-accordion-styles-module__panelGroup--I5The`,
	"panel": `src-js-components-accordion-styles-module__panel--PJH9M`,
	"panelHeading": `src-js-components-accordion-styles-module__panelHeading--U09hT`,
	"panelTitle": `src-js-components-accordion-styles-module__panelTitle--Wiig4`,
	"leftSideIcon": `src-js-components-accordion-styles-module__leftSideIcon--xi23i`,
	"rightSideIcon": `src-js-components-accordion-styles-module__rightSideIcon--Rl6J2`
};
export default ___CSS_LOADER_EXPORT___;
